import { CommonModule, JsonPipe } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { NgbActiveModal, NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../Model/Common/common.service';
import { SessionService } from '../../Util/Session/session.service';
import { SupportTicketService } from '../../Model/Support/support-ticket.service';
import { Router } from '@angular/router';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { NumToWordsService } from '../../Model/Support/NumToWords/num-to-words.service';

@Component({
  selector: 'app-view-salary-slip',
  standalone: true,
  imports: [NgbModule, FormsModule, NgSelectModule, CommonModule, LoaderComponent, JsonPipe, DataTablesModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './view-salary-slip.component.html',
  styleUrl: './view-salary-slip.component.scss'
})
export class ViewSalarySlipComponent {
  isDisabled: boolean = false;
  @Input() InputData: any;
  public user: any = null;
  selectedMonthYear: string = '';
  selectedMonth: string = '';
  selectedYear: string = '';
  PaySlipData = [] as any;

  EmpDetails: any[] = [];
  EmpPaySlip: any[] = [];
  NetPayableInWords: string = '';
  dtoptions: DataTables.Settings = {};
  constructor(public activeModal: NgbActiveModal,
    protected common: CommonService,
    private session: SessionService,
    private support: SupportTicketService,
    private router: Router,
    private dateFormate: CustomDateParserFormatter,
    private NumToWords: NumToWordsService
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    //this.route.params.subscribe(params => this.EmpMasterID = parseInt(params['id']));
    this.dtoptions = { ...this.common.commonDToptions };
  }

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  dtTrigger: Subject<any> = new Subject<any>();

  totalPayable: any;
  totalEarned: any;
  totalDedPayable:any;
  NetPayable: any ;
  Detail = {
    Month: null,
    Holiday: null,
    PaidHolidays: null,
    Payable: null,
    ESICNo: null,
    PFNo: null,
    JoiningDate: null,
    PanNumber: null,
    FirstDate: null,
    LastDate: null,
    UANNo : null,
    WO : null,
    OTHrs : null,
  }
  ngOnInit(): void {
    //this.GetPaySlip();
    this.GeneratePaySlip();
    //this.calculateTotals();
    //console.log(this.InputData);   
  }
  // ngAfterViewInit(): void {
  //   this.dtTrigger.next(null);
  // }

  // ngOnDestroy(): void {
  //   // Do not forget to unsubscribe the event
  //   this.dtTrigger.unsubscribe();
  // }

  Cancel() {
    this.activeModal.close();
  }
  GeneratePaySlip() {
    this.isDisabled = true;
    this.selectedMonthYear = this.InputData.MonthYear;
    const [month, year] = this.selectedMonthYear.split(' ');
    this.selectedMonth = month;
    this.selectedYear = year;
    this.support.GeneratePayslip({ CompanyCode: this.user.CompanyCode, UserId: this.user.UserId, EmpMasterId: this.InputData.EmpMasterId, Month: this.selectedMonth, Year: this.selectedYear,MonthAttendanceID : this.InputData.MonthAttendanceID }).subscribe({
      next: (response) => {
        if (response.EmpPaySlipDetails.length > 0) {
          this.EmpDetails = response.EmpPaySlipDetails;
          this.Detail.Month = this.EmpDetails[0].Month;
          this.Detail.Holiday = this.EmpDetails[0].Holiday;
          this.Detail.PaidHolidays = this.EmpDetails[0].PaidHolidays;
          this.Detail.Payable = this.EmpDetails[0].Payable;
          this.Detail.ESICNo = this.EmpDetails[0].ESICNo;
          this.Detail.PFNo = this.EmpDetails[0].PFNo;
          this.Detail.JoiningDate = this.EmpDetails[0].JoiningDate;
          this.Detail.PanNumber = this.EmpDetails[0].PanNumber;
          this.Detail.FirstDate = this.EmpDetails[0].FirstDate;
          this.Detail.LastDate = this.EmpDetails[0].LastDate;
          this.Detail.UANNo = this.EmpDetails[0].UANNo;
          this.Detail.WO = this.EmpDetails[0].WO;
          this.Detail.OTHrs = this.EmpDetails[0].OTHrs;
        }
        this.EmpPaySlip = response.PaySlipDetails;
        this.calculateTotals();
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
        return true
      },
      error: (err) => {
        this.isDisabled = false;
        return false;
      }
    })
  }
  // GetPaySlip() {
  //   this.isDisabled = true
  //   this.support.GetEmpPayslip({ EmpMasterId: this.user.UserId }).subscribe({
  //     next: (response) => {
  //       try {
  //         if (response.Table != undefined) {
  //           this.PaySlipData = response.Table;
  //           this.PaySlipData.sort((a: { YearName: any; MonthName: string; }, b: { YearName: any; MonthName: string; }) => {
  //             const yearDiff = Number(b.YearName) - Number(a.YearName);
  //             if (yearDiff !== 0) return yearDiff;
  //             const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  //             return months.indexOf(b.MonthName) - months.indexOf(a.MonthName);
  //           });
  //           this.selectedMonthYear = this.PaySlipData[0].MonthName + ' ' + this.PaySlipData[0].YearName;
  //           this.GeneratePaySlip();
  //         } else {
  //           this.PaySlipData = []
  //         }
  //       } catch (e) {
  //         this.PaySlipData = []

  //       }
  //     },
  //     complete: () => {
  //       this.isDisabled = false;
  //       return true
  //     },
  //     error: (err) => {
  //       this.isDisabled = false;
  //       return false;
  //     }
  //   })
  // }
  // EmpPayslip() {
  //   this.GeneratePaySlip();
  // }

  calculateTotals() { 
    this.totalPayable = this.EmpPaySlip.reduce((acc, site) => acc + site.ActualValue, 0).toFixed(2);
    this.totalEarned = this.EmpPaySlip.reduce((acc, site) => acc + site.Value, 0).toFixed(2);
    this.totalDedPayable = this.EmpPaySlip.reduce((acc, site) => acc + site.DED_Value, 0).toFixed(2);
    //this.NetPayable = (this.totalEarned - this.totalDedPayable);
    this.NetPayable = (parseFloat(this.totalEarned) - parseFloat(this.totalDedPayable)).toFixed(2);
    this.NetPayableInWords = this.NumToWords.convertToWords(this.NetPayable);
  }
 
  // TotalPayable(){ 
  //   this.totalPayable = this.EmpPaySlip.reduce((total, shift) => {
  //     return total + shift.ActualValue;
  //   }, 0);
  // }

  onMonthYearChange(): void {
    this.EmpPaySlip = [];
    this.totalPayable = 0;
    this.totalEarned = 0;
    this.totalDedPayable = 0;
    this.NetPayable = 0;
    this.NetPayableInWords = this.NumToWords.convertToWords(0);
  }
}
